import { render, staticRenderFns } from "./filter-columns-modal.vue?vue&type=template&id=360bdc0a&scoped=true&"
import script from "./filter-columns-modal.vue?vue&type=script&lang=js&"
export * from "./filter-columns-modal.vue?vue&type=script&lang=js&"
import style0 from "./filter-columns-modal.vue?vue&type=style&index=0&id=360bdc0a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "360bdc0a",
  null
  
)

export default component.exports